// extracted by mini-css-extract-plugin
export var container = "SearchBar-module--container--13f16";
export var input = "SearchBar-module--input--c5065";
export var inputBlack = "SearchBar-module--inputBlack--37258";
export var lupa = "SearchBar-module--lupa--a0ccf";